import { mutationActions } from '../app-root';
import { TrickyActions } from '@masala-lib/editorial/models/actions/tricky-actions';

export class ChaatTrickyActions extends TrickyActions {
  get mutationActions() {
    return mutationActions;
  }
}
